import {weChatrequest} from '@/utils/request'

// 查询字典数据列表
export function listData(params) {
  return weChatrequest({
    url: `/sys/dictItem/list`,
    method: 'get',
    params
  })
}

// 查询字典数据详细
export function getData(dictCode) {
  return weChatrequest({
    url: '/system/dict/data/' + dictCode,
    method: 'get'
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return weChatrequest({
    url: '/system/dict/data/dictType/' + dictType,
    method: 'get'
  })
}

// 新增字典数据
export function addData(data) {
  return weChatrequest({
    url: '/sys/dictItem/add',
    method: 'post',
    data: data
  })
}

// 修改字典数据
export function updateData(data) {
  return weChatrequest({
    url: '/sys/dictItem/edit',
    method: 'post',
    data: data
  })
}

// 删除字典数据
export function delData(dictCode) {
  return weChatrequest({
    url: '/sys/dictItem/deleteBatch?ids=' + dictCode,
    method: 'DELETE'
  })
}

// 导出字典数据
export function exportData(query) {
  return weChatrequest({
    url: '/system/dict/data/export',
    method: 'get',
    params: query
  })
}
export function getDown() {
  return weChatrequest({
    url: '/system/dict/type/list',
    method: 'get',
  })
}